<template>
  <div>
    <div id="qr-code" style="overflow-x: hidden;">
      <div style="margin: auto; width: 100%" >
        <div class="qrcode">
          <span class="housiwei">{{housiwei}}</span>
          <vue-qr :text="codeValue" :margin="0" :logoSrc="imageUrl" :logoScale="0.15" :size="150" ></vue-qr>
        </div>
      </div>
      <div class="div2">
        <el-row>
          <el-col :span="5" class="biaoti">供暖卡号</el-col>
          <el-col :span="5" class="xiangqing">{{xinXi.clientCode}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="biaoti">用户姓名</el-col>
          <el-col :span="5" class="xiangqing">{{xinXi.clientMstName}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="biaoti">小区名称</el-col>
          <el-col :span="16" class="xiangqing">{{xinXi.housingEstateName}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="biaoti">楼牌住址</el-col>
          <el-col :span="16" class="xiangqing">{{xinXi.housingAdd}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="biaoti">商网名称</el-col>
          <el-col :span="17" class="xiangqing">{{xinXi.clientMstSellerName}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="5" class="biaoti">联系电话</el-col>
          <el-col :span="5" class="xiangqing">{{xinXi.clientMstMobile}}</el-col>
        </el-row>
      </div>
      <div class="div3">
        <el-row>
          <el-col class="mianji" style="font-weight: bolder">供暖面积（平方米）</el-col>
        </el-row>
        <el-row>
          <el-col :span="5" style="margin-left: 5%">住宅面积</el-col>
          <el-col :span="5" style="margin-left: 3%;margin-top: 2px">{{xinXi.residentArea}}</el-col>
          <el-col :span="5" style="margin-left: 2%">商网面积</el-col>
          <el-col :span="5" style="margin-left: 3%;margin-top: 2px">{{xinXi.houseMstSellerArea}}</el-col>
        </el-row>
        <el-row>
          <el-col :span="5" style="margin-left: 5%">企业面积</el-col>
          <el-col :span="5" style="margin-left: 3%;margin-top: 2px">{{xinXi.houseMstOther1Area}}</el-col>
          <el-col :span="5" style="margin-left: 2%">其他面积</el-col>
          <el-col :span="5" style="margin-left: 3%;margin-top: 2px">{{xinXi.houseMstOther2Area}}</el-col>
        </el-row>
      </div>
    </div>
    <div class="div4">
      <el-button style="width: 70%;" size="small" @click="back()" type="success">返回</el-button>
    </div>
  </div>
</template>

<script>
  import VueQr from 'vue-qr'
  import {Toast} from 'mint-ui'

  export default {
    name: "qrCode",
    data() {
      return {
        housiwei: '',
        //6658
        codeValue: this.$route.query.codeId,
        //13251236685455256658
        imageUrl: require('../assets/15.jpg'),
        xinXi: {
          clientCode: '',
          clientMstName: '',
          housingEstateName: '',
          housingAdd: '',
          clientMstSellerName: '',
          clientMstMobile: '',
          residentArea: '',
          houseMstSellerArea: '',
          houseMstOther1Area: '',
          houseMstOther2Area: ''
        },
      }
    },
    mounted() {
      this.getData();
    },
    methods: {
      getData() {
        let params = {
          clientCode: this.codeValue
        }
        this.$http.getClientDetails(params).then(response => {
          if (response.state === 0) {
            Toast({
              duration: 2000,
              message: response.msg
            })
          } else {
            let value = response.data.row[0]
            this.housiwei = value.clientCode.substring(value.clientCode.length - 4);
            if (value.clientMstName.length > 0) {
              // value.clientMstName.substr(-1)
              // '**' + this.userName.substr(-1)
              value.clientMstName = '**' +  value.clientMstName.substr(-1)
            }
            if (value.clientMstMobile !== "-") {
              value.clientMstMobile = value.clientMstMobile.replace(/(\d{3})\d{5}(\d{3})/, "$1*****$2");
            }
            this.xinXi = value
          }
        })
      },
      back() {
        this.$router.go(-1);
      }
    },
    components: {
      VueQr
    },
  }

</script>

<style scoped>
  #qr-code {
    position: absolute;
    width: 100%;
    height: 91%;
    top: 0;
    left: 0;
    overflow-y: auto;
  }

  .qrcode {
    /*display:inline-block;*/
    width: 150px;
    margin: auto;
    /*margin-left: 110px;*/
    margin-top:20px;
    margin-bottom: 5%;
  }

  .biaoti {
    font-weight: bolder;
    margin-left: 6%;
  }

  .xiangqing {
    margin-left: 2%;
  }

  .div2 {
    padding-top: 3%;
    border: 1px;
    border-style: solid;
    border-color: gainsboro white white;
  }

  .div3 {
    margin-top: 5%;
    padding-top: 3%;
    border: 1px;
    border-style: solid;
    border-color: gainsboro white white;
  }

  .el-row {
    margin-top: 5%;
  }

  .mianji {
    margin-left: 4%;
  }

  .div4 {
    position: fixed;
    bottom: 0px;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.2);
    background-color: #fff;
  }

  .housiwei {
    /*margin: auto;*/
    position: absolute;
    background-color: black;
    color: white;
    /*float: left;*/

    margin-left: 56px;
    margin-top: 68px;
  }
</style>



// WEBPACK FOOTER //
// src/pages/qrCode.vue